import axios from '@/utils/axios';
import {
    ChartDataParamsType,
    BatchChartDataParamsType,
    ResponseProject,
    ResponseDashboardDetail,
    ResponseChartData,
    ResponseBatchChartData
} from '../types';

// 查询project 也就是查询小游戏这个大盘
export async function project(projectCode: string) {
    return await axios.post<ResponseProject>('/portal/app/miniGame/data/project/query', { projectCode });
}

// 查询dashboard 配置项在此接口
export async function dashboardDetail(dashboardCode: string) {
    return await axios.post<ResponseDashboardDetail>('/portal/app/miniGame/data/dashboard/query', { dashboardCode });
}

// 查询图表数据
export async function chartData(params: ChartDataParamsType) {
    return await axios.post<ResponseChartData>('/portal/app/miniGame/data/data/query', params);
}

// 批量查询图表
export async function batchChart(params: BatchChartDataParamsType) {
    return await axios.post<ResponseBatchChartData>('/portal/app/miniGame/data/data/multiQuery', params);
}

// 下载图表数据
export async function chartDownload(params: ChartDataParamsType) {
    return await axios.post<any>('/portal/app/miniGame/data/download', params);
}
